import { get, isEmpty } from 'lodash'
import React, { ReactNode, useState } from 'react'
import Measure from 'react-measure'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'

import { TTheme } from '../ThemeContext'
import Header from './Header'
import Navbar from './Navbar'
import { TItemNavbar } from './Navbar/Item'

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  background-color: white;
  z-index: 100;

  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
`

const defaultTheme = {
  barColor: 'rgb(167, 31, 60)',
  headerTextColor: 'white',
  linkColor: 'white', // rgba(50, 58, 70, 0.7)
}

export type TTopbar = {
  theme?: TTheme
  fluidNav?: boolean
  fluidHeader?: boolean
  fluid?: boolean
  enableAdminWarningMode?: boolean
  twoFaEnabled?: boolean
  showManual?: boolean
  subtext?: string
  isStaging?: boolean
  coloredHeader?: boolean
  rightItems?: any[]
  centerItems?: React.ReactNode[]
  showLanguageSelect?: boolean
  useDarkMode?: boolean
  showGlobalUserSelect?: boolean
  showGlobalWindow?: boolean
  globalItem?: {
    [key: string]: any
  }
  statusPanelConfig?: {
    show?: boolean
    url?: string
  }
  logo?: string
  text?: string
  twoFaForced?: boolean
  topPushEnabled?: boolean
  items?: TItemNavbar[]
  maxLevelDumpsterFireDispo?: ReactNode
}
const Topbar = (props: TTopbar): React.ReactElement => {
  const {
    theme = defaultTheme,
    fluidNav,
    fluidHeader,
    fluid,
    enableAdminWarningMode = false,
    twoFaEnabled = false,
    twoFaForced = false,
    showManual,
    maxLevelDumpsterFireDispo,
  } = props

  const adminWarningTheme = {
    barColor: 'rgb(167, 31, 60)',
    headerTextColor: 'red',
    linkColor: 'red', // rgba(50, 58, 70, 0.7)
  }

  const [isToggled, setIsToggled] = useState(false)
  const [bounds, setBounds] = useState({ height: 0 })

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const onToggle = (): void => setIsToggled(!isToggled)

  const onResize = (rect): void => {
    // console.log("onResize", rect)
    setBounds({ height: get(rect, 'bounds.height') })
  }

  const onLinkClick = (item = {}): void => {
    const { children }: { children?: React.ReactNode } = item
    if (!isMobile || isEmpty(children)) {
      setIsToggled(false)
    }
  }

  return (
    <React.Fragment>
      <Measure bounds onResize={onResize}>
        {({ measureRef }) => (
          <Wrapper ref={measureRef} className="components/Topbar">
            <Header
              {...props}
              fluid={fluidHeader !== undefined ? fluidHeader : fluid}
              isToggled={isToggled}
              onToggle={onToggle}
              theme={enableAdminWarningMode ? adminWarningTheme : theme}
              showManual={showManual}
              enableAdminWarningMode={enableAdminWarningMode}
              twoFaEnabled={twoFaEnabled}
              twoFaForced={twoFaForced}
            />
            <Navbar
              {...props}
              fluid={fluidNav !== undefined ? fluidNav : fluid}
              isToggled={isToggled}
              theme={enableAdminWarningMode ? adminWarningTheme : theme}
              onLinkClick={onLinkClick}
              maxLevelDumpsterFireDispo={maxLevelDumpsterFireDispo}
            />
          </Wrapper>
        )}
      </Measure>
      <div
        style={{
          minHeight: `${bounds.height}px`,
          height: `${bounds.height}px`,
          border: '0px solid lime',
        }}
      />
    </React.Fragment>
  )
}

export default Topbar
